import InputDropdown from "../inputs/inputDropdown/inputDropdown";

const TimeDropdown = ({ selectedTime, onTimeChange }) => {
    const timeOptions = Array.from({ length: 24 * 4 }, (_, i) => {
        const hour = Math.floor(i / 4)
            .toString()
            .padStart(2, "0");
        const minute = (i % 4) * 15;
        const formattedMinute = minute.toString().padStart(2, "0");
        return {
            label: `${hour}:${formattedMinute}`,
            value: `${hour}:${formattedMinute}`,
        };
    });

    const handleTimeSelect = (selectedOption) => {
        onTimeChange(selectedOption.value);
    };

    return (
        <div className="time-selector">
            <InputDropdown
                options={timeOptions}
                onSelect={handleTimeSelect}
                value={
                    selectedTime
                        ? { label: selectedTime, value: selectedTime }
                        : { label: "Selecciona hora", value: null }
                }
                placeholder="Selecciona la hora de despliegue"
                label="Hora de despliegue"
                showLabel={true}
            />
        </div>
    );
};

export default TimeDropdown;
